module.exports = __webpack_public_path__ + "static/media/logo-dia-dos-namorados-fundo-branco.d3380721.svg";